var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-sg"},[_c('wt-button',{attrs:{"type":"primary","icon":'wticon-plus2',"text":_vm.title},on:{"click":_vm.click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }